
 import { io } from 'socket.io-client';
 console.log('[INIT] longTournamentSocket.js загружен');

 const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'http://localhost:5000';

 const longTournamentSocket = io(`${SOCKET_URL}/long-tournament`, {
   autoConnect: false,
   transports: ['websocket'],
 });
 
 const eventQueue = []; 

// 🧹 общий хелпер очистки локального «якоря» активного турнирного стола
function clearActiveTableAnchor() {
  try {
  localStorage.removeItem('long:lastActiveTableId');
   sessionStorage.removeItem('long:lastActiveTableId');
   // ЛЕГАСИ-ключ, из-за которого тебя редиректит
   localStorage.removeItem('tableId');          // 👈 важно
   sessionStorage.removeItem('tableId');
   // на всякий — короткие турниры, если такие же якоря были
   localStorage.removeItem('short:lastActiveTableId');
   sessionStorage.removeItem('short:lastActiveTableId');
  } catch {}
}

// 🔁 запросить у сервера актуальный активный стол и синхронизировать локальный ключ
export function syncActiveTableFromServer(cb) {
  if (!longTournamentSocket.connected) return;
  longTournamentSocket.emit('long_getMyActiveTable', (payload) => {
    if (payload && payload.tableId) {
      localStorage.setItem('long:lastActiveTableId', String(payload.tableId));
    } else {
      clearActiveTableAnchor();
    }
    if (typeof cb === 'function') cb(payload || null);
  });
}


longTournamentSocket.on('connect', () => {
  console.log('[CLIENT] longTournamentSocket подключён');

  // 1) отстреливаем отложенные события (если что-то успели накопить)
  while (eventQueue.length > 0) {
    const { event, payload } = eventQueue.shift();
    longTournamentSocket.emit(event, payload);
  }

  // 2) пробуем восстановить активный стол из LocalStorage/SessionStorage
  let storedId = null;
  try {
    storedId =
      sessionStorage.getItem('long:lastActiveTableId') ||
      localStorage.getItem('long:lastActiveTableId') ||
      sessionStorage.getItem('tableId') ||
      localStorage.getItem('tableId');
  } catch (e) {
    console.warn('[longTournament] cannot read localStorage', e);
  }

  const username =
    (typeof window !== 'undefined' && localStorage.getItem('username')) || '';

  if (storedId && username) {
    const tableIdNum = Number(storedId);
    if (Number.isFinite(tableIdNum) && tableIdNum > 0) {
      console.log(
        '[CLIENT] Rejoin long table after reconnect:',
        tableIdNum,
        'user =',
        username
      );

      // 🔁 снова заходим в комнату стола
      longTournamentSocket.emit('joinLongTable', {
        longTableId: tableIdNum,
        playerUsername: username,
      });

      // 🔁 и сразу просим актуальное состояние доски
      longTournamentSocket.emit('longFetchData', tableIdNum);
    }
  }

  // 3) синхронизируем «якорь» с сервера (если там нет активного — чистим локальные ключи)
  syncActiveTableFromServer((payload) => {
    if (!payload || !payload.tableId) {
      clearActiveTableAnchor();
    }
  });
});

//  longTournamentSocket.on('connect', () => {
//    console.log('[CLIENT] longTournamentSocket подключён');
//    while (eventQueue.length > 0) {
//      const { event, payload } = eventQueue.shift();
//      longTournamentSocket.emit(event, payload);
//    }

//   // ⤴️ сразу после подключения подтягиваем «правду» с сервера
//   syncActiveTableFromServer((payload) => {
//    if (!payload || !payload.tableId) {
//      // нет активного — точно вычищаем всё наследие
//      clearActiveTableAnchor();
//    }
//  });
//  });
 
 export function safeEmit(event, payload) {
   console.log('[SAFE EMIT]', event, payload, '| connected:', longTournamentSocket.connected);
   if (longTournamentSocket.connected) {
     longTournamentSocket.emit(event, payload);
   } else {
     eventQueue.push({ event, payload });
   }
 }
 
 /* ⬇️ ДОБАВЬ: авторизация токеном + подключение */
 export function ensureLongTournamentSocketAuthAndConnect() {
   try {
     const token = localStorage.getItem('token') || '';
     const username = localStorage.getItem('username') || ''; // 👈 ОБЯЗАТЕЛЬНО
     // Отдаём ОБА поля в auth для handshake
     longTournamentSocket.auth = { token, username };
   } catch {}
 
   if (!longTournamentSocket.connected && !longTournamentSocket.connecting) {
     longTournamentSocket.connect();
   }
 }
 
 /* твой старый хелпер можно оставить, если где-то нужен username */
 export function ensureLongSocket(username) {
   if (!username) return;
   if (longTournamentSocket.connected || longTournamentSocket.connecting) return;
   longTournamentSocket.auth = { username };
   longTournamentSocket.connect();
 }
 
// 👂 события от сервера, при которых надо забыть «якорь» активного стола
longTournamentSocket.on('long_clearActiveTable', clearActiveTableAnchor);
longTournamentSocket.on('long_tableClosed',      clearActiveTableAnchor);
longTournamentSocket.on('long_gameFinished',     clearActiveTableAnchor);

// полезный экспорт — можно вызывать перед переходом на кеш-стол
export function forgetLongAnchor() {
  clearActiveTableAnchor();
}
 
 export default longTournamentSocket;





















//  import { io } from 'socket.io-client';
// console.log('[INIT] longTournamentSocket.js загружен');

// const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'http://localhost:5000';

// const longTournamentSocket = io(`${SOCKET_URL}/long-tournament`, {
//   autoConnect: false,
//   transports: ['websocket'],
// });

// const eventQueue = [];

// // 🧹 общий хелпер очистки локального «якоря» активного турнирного стола
// function clearActiveTableAnchor() {
//   try {
//     localStorage.removeItem('long:lastActiveTableId');
//     sessionStorage.removeItem('long:lastActiveTableId');
//     // ЛЕГАСИ-ключ, из-за которого тебя редиректит
//     localStorage.removeItem('tableId');          // 👈 важно
//     sessionStorage.removeItem('tableId');
//     // на всякий — короткие турниры, если такие же якоря были
//     localStorage.removeItem('short:lastActiveTableId');
//     sessionStorage.removeItem('short:lastActiveTableId');
//   } catch {}
// }

// // 🔁 запросить у сервера актуальный активный стол и синхронизировать локальный ключ
// export function syncActiveTableFromServer(cb) {
//   if (!longTournamentSocket.connected) return;
//   longTournamentSocket.emit('long_getMyActiveTable', (payload) => {
//     if (payload && payload.tableId) {
//       localStorage.setItem('long:lastActiveTableId', String(payload.tableId));
//     } else {
//       clearActiveTableAnchor();
//     }
//     if (typeof cb === 'function') cb(payload || null);
//   });
// }

// longTournamentSocket.on('connect', () => {
//   console.log('[CLIENT] longTournamentSocket подключён');

//   // 1) отстреливаем отложенные события (если что-то успели накопить)
//   while (eventQueue.length > 0) {
//     const { event, payload } = eventQueue.shift();
//     longTournamentSocket.emit(event, payload);
//   }

//   // 2) пробуем восстановить активный стол из LocalStorage/SessionStorage
//   let storedId = null;
//   try {
//     storedId =
//       sessionStorage.getItem('long:lastActiveTableId') ||
//       localStorage.getItem('long:lastActiveTableId') ||
//       sessionStorage.getItem('tableId') ||
//       localStorage.getItem('tableId');
//   } catch (e) {
//     console.warn('[longTournament] cannot read localStorage', e);
//   }

//   const username =
//     (typeof window !== 'undefined' && localStorage.getItem('username')) || '';

//   if (storedId && username) {
//     const tableIdNum = Number(storedId);
//     if (Number.isFinite(tableIdNum) && tableIdNum > 0) {
//       console.log(
//         '[CLIENT] Rejoin long table after reconnect:',
//         tableIdNum,
//         'user =',
//         username
//       );

//       // 🔁 снова заходим в комнату стола
//       longTournamentSocket.emit('joinLongTable', {
//         longTableId: tableIdNum,
//         playerUsername: username,
//       });

//       // 🔁 и сразу просим актуальное состояние доски
//       longTournamentSocket.emit('longFetchData', tableIdNum);
//     }
//   }

//   // 3) синхронизируем «якорь» с сервера (если там нет активного — чистим локальные ключи)
//   syncActiveTableFromServer((payload) => {
//     if (!payload || !payload.tableId) {
//       clearActiveTableAnchor();
//     }
//   });
// });

// export function safeEmit(event, payload) {
//   console.log('[SAFE EMIT]', event, payload, '| connected:', longTournamentSocket.connected);
//   if (longTournamentSocket.connected) {
//     longTournamentSocket.emit(event, payload);
//   } else {
//     eventQueue.push({ event, payload });
//   }
// }

// /* ⬇️ ДОБАВЬ: авторизация токеном + подключение */
// export function ensureLongTournamentSocketAuthAndConnect() {
//   try {
//     const token = localStorage.getItem('token') || '';
//     const username = localStorage.getItem('username') || ''; // 👈 ОБЯЗАТЕЛЬНО
//     // Отдаём ОБА поля в auth для handshake
//     longTournamentSocket.auth = { token, username };
//   } catch {}

//   if (!longTournamentSocket.connected && !longTournamentSocket.connecting) {
//     longTournamentSocket.connect();
//   }
// }

// /* твой старый хелпер можно оставить, если где-то нужен username */
// export function ensureLongSocket(username) {
//   if (!username) return;
//   if (longTournamentSocket.connected || longTournamentSocket.connecting) return;
//   longTournamentSocket.auth = { username };
//   longTournamentSocket.connect();
// }

// // 👂 события от сервера, при которых надо забыть «якорь» активного стола
// longTournamentSocket.on('long_clearActiveTable', clearActiveTableAnchor);
// longTournamentSocket.on('long_tableClosed',      clearActiveTableAnchor);
// longTournamentSocket.on('long_gameFinished',     clearActiveTableAnchor);

// // полезный экспорт — можно вызывать перед переходом на кеш-стол
// export function forgetLongAnchor() {
//   clearActiveTableAnchor();
// }

// export default longTournamentSocket;

























// import { io } from 'socket.io-client';
// console.log('[INIT] longTournamentSocket.js загружен');

// const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'http://localhost:5000';

// const longTournamentSocket = io(`${SOCKET_URL}/long-tournament`, {
//   autoConnect: false,
//   transports: ['websocket'],
// });

// const eventQueue = [];

// longTournamentSocket.on('connect', () => {
//   console.log('[CLIENT] longTournamentSocket подключён');
//   while (eventQueue.length > 0) {
//     const { event, payload } = eventQueue.shift();
//     longTournamentSocket.emit(event, payload);
//   }
// });

// export function safeEmit(event, payload) {
//   console.log('[SAFE EMIT]', event, payload, '| connected:', longTournamentSocket.connected);
//   if (longTournamentSocket.connected) {
//     longTournamentSocket.emit(event, payload);
//   } else {
//     eventQueue.push({ event, payload });
//   }
// }

// /* ⬇️ ДОБАВЬ: авторизация токеном + подключение */
// export function ensureLongTournamentSocketAuthAndConnect() {
//   try {
//     const token = localStorage.getItem('token') || '';
//     const username = localStorage.getItem('username') || ''; // 👈 ОБЯЗАТЕЛЬНО
//     // Отдаём ОБА поля в auth для handshake
//     longTournamentSocket.auth = { token, username };
//   } catch {}

//   if (!longTournamentSocket.connected && !longTournamentSocket.connecting) {
//     longTournamentSocket.connect();
//   }
// }


// /* твой старый хелпер можно оставить, если где-то нужен username */
// export function ensureLongSocket(username) {
//   if (!username) return;
//   if (longTournamentSocket.connected || longTournamentSocket.connecting) return;
//   longTournamentSocket.auth = { username };
//   longTournamentSocket.connect();
// }

// export default longTournamentSocket;





// // longTournamentSocket.js
// import { io } from 'socket.io-client';
// console.log('[INIT] longTournamentSocket.js загружен');

// // Берём полный адрес из .env
// const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// const longTournamentSocket = io(`${API_URL}/long-tournament`, {
//   autoConnect: false,
//   transports: ['websocket'],
// });

// // Очередь событий, чтобы не терять их до коннекта
// const eventQueue = [];

// longTournamentSocket.on('connect', () => {
//   console.log('[CLIENT] longTournamentSocket подключён');

//   while (eventQueue.length > 0) {
//     const { event, payload } = eventQueue.shift();
//     longTournamentSocket.emit(event, payload);
//   }
// });

// export function safeEmit(event, payload) {
//   console.log('[SAFE EMIT]', event, payload, '| connected:', longTournamentSocket.connected);
//   if (longTournamentSocket.connected) {
//     longTournamentSocket.emit(event, payload);
//   } else {
//     eventQueue.push({ event, payload });
//   }
// }

// export function ensureLongSocket(username) {
//   if (!username) return;
//   if (longTournamentSocket.connected || longTournamentSocket.connecting) return;

//   longTournamentSocket.auth = { username };
//   longTournamentSocket.connect();
// }

// export default longTournamentSocket;










// // longTournamentSocket.js
// import { io } from 'socket.io-client';
// console.log('[INIT] longTournamentSocket.js загружен');

// const API_URL = process.env.REACT_APP_API_URL || 'localhost';
// const PORT = process.env.REACT_APP_PORT || '5000';

// const socketUrl = `http://${API_URL}:${PORT}`;

// const longTournamentSocket = io(`${socketUrl}/long-tournament`, {
//   autoConnect: false,
//   transports: ['websocket'],
// });

// // Добавим вспомогательную очередь событий:
// const eventQueue = [];

// longTournamentSocket.on('connect', () => {
//   console.log('[CLIENT] longTournamentSocket подключён');

//   // отправим всё накопленное
//   while (eventQueue.length > 0) {
//     const { event, payload } = eventQueue.shift();
//     longTournamentSocket.emit(event, payload);
//   }
// });

// export function safeEmit(event, payload) {
//   console.log('[SAFE EMIT]', event, payload, '| connected:', longTournamentSocket.connected);
//   if (longTournamentSocket.connected) {
//     longTournamentSocket.emit(event, payload);
//   } else {
//     eventQueue.push({ event, payload });
//   }
// }

// export function ensureLongSocket(username) {
//   if (!username) return;
//   if (longTournamentSocket.connected || longTournamentSocket.connecting) return;

//   longTournamentSocket.auth = { username };
//   longTournamentSocket.connect();
// }

// export default longTournamentSocket;

// longTournamentSocket.js
// import { io } from 'socket.io-client';

// const API_URL = process.env.REACT_APP_API_URL || 'localhost';
// const PORT = process.env.REACT_APP_PORT || '5000';

// const socketUrl = `http://${API_URL}:${PORT}`;

// // Сокет создаётся, но не подключается сам
// const longTournamentSocket = io(`${socketUrl}/long-tournament`, {
//   autoConnect: false,            // ⬅️ ВАЖНО: вручную подключим
//   transports: ['websocket'],    // ⬅️ для надёжности
// });

// // Хелпер: подключиться с указанием username
// export function ensureLongSocket(username) {
//   if (!username) return;
//   if (longTournamentSocket.connected) return;

//   longTournamentSocket.auth = { username };
//   longTournamentSocket.connect();
// }

// export default longTournamentSocket;








 
// import { io } from 'socket.io-client';

// const API_URL = process.env.REACT_APP_API_URL;
// const PORT = process.env.REACT_APP_PORT;

// const socketUrl = `http://${API_URL}:${PORT}`;

// // 👇 Это то, что вам нужно
// const longTournamentSocket = io(`${socketUrl}/long-tournament`, {
//   autoConnect: false,
// });

// export default longTournamentSocket;
